<app-navigation>
  <main><router-outlet></router-outlet></main>
</app-navigation>
